<template>
  <section class="section full-height">
    <admin-section-header icon="view-grid" title="Productos" />
    <div class="columns">
      <div class="column is-three-quarters">
        <dashboard-banner-tile
          title=""
          subtitle=""
          :blur="false"
          ctaText=""
          ctaTarget="admin.onBoard.list"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2021-02-12-shutterstock_1490142176.jpg"
        >
          <img
            style="visibility: hidden;"
            src="https://elitek-s3.s3.amazonaws.com/2021-02-12-shutterstock_1490142176.jpg"
          />
          <b-button size="is-large"
            style="position: absolute; left: 50%; top: 54%;"
            type="is-primary"
            >{{ $t('Acceder') }}</b-button
          >
        </dashboard-banner-tile>
      </div>
      <div class="column is-one-quarter twitter">
        <TwitterFeed profile="bancomundial" />
      </div>
    </div>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TwitterFeed from '@/components/admin/dasboard/TwitterFeed.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Products',
  components: {
    AdminSectionHeader,
    TwitterFeed,
    DashboardBannerTile
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Products'],
      title: 'Products'
    })
  }
}
</script>

<style lang="scss" scoped>
button.is-large {
  width: max-content;
  height: max-content;
}
.button-grid button {
  margin: 10px 10px;
  border-color: var(--rosa-dark-eco);
}
</style>
